import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION8A: PdfComponent = {
  type: 'section',
  id: 's8A',
  title: '8A. Commission and Payment Terms',
  content: [
    {
      type: 'bulletList',
      id: 's8Abullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Kanda may, at its sole discretion, pay commission or other remuneration to the Subscriber in connection with Completed Loans or other qualifying transactions.',
        },
        {
          copy: "The amount, timing, and basis of any such commission shall be as separately agreed in writing between Kanda and the Subscriber and may be subject to change or withdrawal at Kanda's discretion. Kanda may also impose conditions, clawback rights, or volume thresholds related to such payments.",
        },
        {
          copy: 'Any commission payable is exclusive of VAT unless expressly stated otherwise. Kanda may offset any sums due to the Subscriber against sums owed by the Subscriber to Kanda under this Agreement.',
        },
        {
          copy: 'The Subscriber acknowledges that receipt of any commission is contingent on:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Full compliance with the terms of this Agreement;',
              },
              {
                copy: 'No material breach or misrepresentation by the Subscriber;',
              },
              {
                copy: "Kanda's receipt of cleared funds in respect of the applicable finance transaction.",
              },
            ],
          },
        },
        {
          copy: 'For the avoidance of doubt, the Subscriber shall not be entitled to any commission on Cancelled Loans, transactions that are later refunded or unwound, or where the Customer has not received the goods or services in accordance with this Agreement.',
        },
      ],
      prefix: '8A',
    },
  ],
};
